import agent from "./agent";
import { ApiFactory } from "./ApiFactory";

export default class ClaimsApi {
    private apiFactory: ApiFactory;

    constructor(apiFactory: ApiFactory) {
        this.apiFactory = apiFactory;
    }
   
    getClaimHistory = async (params: any) => {
        try {
            const response = await agent.api.get(`/warrantyclaim/GetList`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    getDetailsByClaim = async (params: any) => {
        try {
            const response = await agent.api.get(`/warrantyclaim/GetClaim`, params);

            console.log(response);

            return response;
        }
        catch (error) {
            throw error;
        }
    };

    getDetailsByHin = async (params: any) => {
        try {
            const response = await agent.api.get(`/warrantyclaim/GetDetailsFromHin`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    };

    saveWarrantyClaim = async (params: any) => {
        try {
            const response = await agent.api.post(`/warrantyclaim/SaveClaim`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    saveWarrantyClaimMedia = async (params: any) => {
        try {
            const response = await agent.api.post(`/warrantyclaim/AddMedia`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    deleteWarrantyClaimMedia = async (params: any) => {
        try {
            const response = await agent.api.del(`/warrantyclaim/DeleteMedia`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    downloadWarrantyClaimMedia = async (params: any, fileType : string) => {
        try {
            const response = await agent.api.downloadDocument(`/warrantyclaim/DownloadMedia`, params, fileType);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

    deleteWarrantyClaim = async (params: any) => {
        try {
            const response = await agent.api.del(`/warrantyclaim/DeleteClaim?claimNumber=${params}`);
            return response;
        }
        catch (error) {
            throw error;
        }
    }
}